import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { Languages } from 'core/localization/entities';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: { order: ['path', 'querystring', 'navigator'] },
    fallbackLng: Languages.EN,
    supportedLngs: Object.values(Languages),
    lowerCaseLng: true,
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
